import React from 'react'
import { BiMinus, BiPlus } from 'react-icons/bi'
import { Button } from 'reactstrap'

export default function PlusMinusInput({value,min,max,onChange}) {

    const onAdd=()=>{
        if(value + 1 >= max){
            
        }else{
            onChange(value+1)
        }
    }

    const onSubstract=()=>{
        if(value - 1 < min){
            
        }else{
            onChange(value-1)
        }
    }
  return (
    <div style={{
        display:"flex",
        alignItems:"center",
        gap:"5px"
    }}>

        <Button color="danger" size={"sm"} onClick={onSubstract}>
            <BiMinus size={18} />
        </Button>
        <span className="mx-2">
            {value}
        </span>
        <Button color="success" size={"sm"} onClick={onAdd}>
            <BiPlus size={18} />
        </Button>

    </div>
  )
}
